import React from 'react'

const getPath = (dir) => {
  if (dir === 'up')
    return 'M12 9.31l6.97 6.97a.75.75 0 0 0 1.06-1.06l-7.5-7.5a.75.75 0 0 0-1.06 0l-7.5 7.5a.75.75 0 0 0 1.06 1.06L12 9.31z'

  if (dir === 'left')
    return 'M9.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 0 0 1.06-1.06L9.31 12z'

  if (dir === 'right')
    return 'M14.69 12l-6.97 6.97a.75.75 0 0 0 1.06 1.06l7.5-7.5a.75.75 0 0 0 0-1.06l-7.5-7.5a.75.75 0 0 0-1.06 1.06L14.69 12z'

  return 'M12 14.69L5.03 7.72a.75.75 0 0 0-1.06 1.06l7.5 7.5a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 0 0-1.06-1.06L12 14.69z'
}

const ChevronIcon = ({ dir = 'down', width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill={fill} width={width} height={height} {...props}>
    <path d={getPath(dir)} />
  </svg>
)

export default ChevronIcon
